require('./bootstrap');

var heroGlider = document.querySelectorAll('.h-slider');
const hGliderConf = {
    slidesToShow: "auto",
    slidesToShow: 1,
    slidesToScroll: 1,
    scrollLock: true,
    draggable: true,
    arrows: {
        prev: '.h-slider-prev',
        next: '.h-slider-next'
    }
};
heroGlider.forEach(item => {
    const glider = new Glider(item, hGliderConf);
    slideAutoPlay(glider, '.h-slider')
});


var mpMovieGlider = document.querySelectorAll('.m-slider');
const mpMovieGliderConf = {
    slidesToShow: "auto",
    slidesToShow: 1,
    slidesToScroll: 1,
    scrollLock: true,
    draggable: true,
    arrows: {
        prev: '.m-slider-prev',
        next: '.m-slider-next'
    },
    responsive: [
        {
            breakpoint: 1100,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        }
    ]
};
mpMovieGlider.forEach(item2 => {
    new Glider(item2, mpMovieGliderConf);
});

function slideAutoPlay(glider, selector, delay = 5000, repeat = true) {
    let autoplay = null;
    const slidesCount = glider.track.childElementCount;
    let nextIndex = 1;
    let pause = true;

    function slide() {
        autoplay = setInterval(() => {
            if (nextIndex >= slidesCount) {
                if (!repeat) {
                    clearInterval(autoplay);
                } else {
                    nextIndex = 0;
                }
            }
            glider.scrollItem(nextIndex++);
        }, delay);
    }

    slide();

    var element = document.querySelector(selector);
    element.addEventListener('mouseover', (event) => {
        if (pause) {
            clearInterval(autoplay);
            pause = false;
        }
    }, 300);

    element.addEventListener('mouseout', (event) => {
        if (!pause) {
            slide();
            pause = true;
        }
    }, 300);
}

sleep = function (num) {
    var now = new Date();
    var stop = now.getTime() + num;
    while (true) {
        now = new Date();
        if (now.getTime() > stop) return;
    }
}

$(function () {

    $('.ajax-form').on('submit', function (event) {
        event.preventDefault();
        var form = $(this);
        $('.alert').remove();
        $.ajax({
            type: "POST",
            url: $(this).attr('action'),
            data: $(this).serialize(),
            cache: false,
            success: function (data) {
                form.append('<div class="alert alert-success w-100 mt-3 mb-0" role="alert"><p>' + data.message + '</p></div>');
            },
            error: function (data) {
                form.append('<div class="alert alert-danger w-100 mt-3 mb-0" role="alert"></div>');
                $.each(data.responseJSON.errors, function (key, value) {
                    form.children('.alert').append('<p>' + value + '</p>');
                });
            }
        });
    });

    // if ($(window).width() < 768) {
    //     glider.destroy();
    // }

    // $('.form').submit(function (e) {
    //     e.preventDefault();
    //     var $curr = $(this);
    //     $('.submit', $curr).attr("disabled", "disabled");
    //     $.ajax({
    //         type: "POST",
    //         url: $curr.attr("action"),
    //         data: $curr.serialize(),
    //         dataType: "json",
    //         cache: false,
    //         success: function (data) {
    //             $('.submit', $curr).attr("disabled", false);
    //             $('[name="email"]', $curr).val('');
    //             iziToast.success({
    //                 message: data.message
    //             });
    //         },
    //         error: function (data) {
    //             $('.submit', $curr).attr("disabled", false);
    //             var validationErr = '';

    //             if (data.responseJSON != undefined) {
    //                 $.each(data.responseJSON.errors, function (key, value) {
    //                     validationErr += value[0] + '<br/>';
    //                 });

    //                 iziToast.error({
    //                     message: validationErr
    //                 });
    //             }
    //         }
    //     });
    // });

    // $('.select-nav ul li').click(function () {
    //     var c = $(this).parent().children().length;
    //     $(this).siblings().addBack().children().remove();
    //     var a = $(this).siblings().toggle();
    //     if ($(a).is(":visible") === true) {
    //         $(this).parents('.select-nav>ul').css('height', c * 72).addClass('opened');
    //     }
    //     else {
    //         $(this).parents('.select-nav>ul').css('height', 72).removeClass('opened');
    //         console.log($(this).attr('value')); //Value
    //     }
    //     $(this).parent().prepend(this);
    // });

    // var $select = $('.select-nav');

    // $(document).mouseup(e => {
    //     if (!$select.is(e.target)
    //         && $select.has(e.target).length === 0) {
    //         var $ul = $select.children('ul');
    //         $ul.children('li:not(:first-child)').css('display', 'none');
    //         $ul.css('height', 72).removeClass('opened');
    //     }
    // });

    // $('#mainnav').on('show.bs.collapse', function () {
    //     $(this).parents('body').addClass('disable-scroll');
    // });
    // $('#mainnav').on('hide.bs.collapse', function () {
    //     $(this).parents('body').removeClass('disable-scroll');
    // });

    // $('.dropdown-toggle').attr('data-toggle', 'dropdown');

    // $('.searchbox').on('focus', function () {
    //     $(this).next('p').hide();

    // });
    // $('.searchbox').on('blur', function () {
    //     if (!$(this).val()) {
    //         $(this).next('p').show();
    //     }
    // });

    // $(document).keyup(function (e) {
    //     if (e.keyCode == 27) { // escape key maps to keycode `27`
    //         $('.navbar').removeClass('open')
    //     }
    // });
});
